import { PLAN_TEAM } from '@/constants/userSubscriptionPlans'
import { PERMISSION_TYPE, type PERMISSION_VALUE } from '@/permissions'
import { ROLE_TYPE } from '../permissions'

export enum ESTIMATE_PERMISSION {
  MAKE_PRIVATE = 'MAKE_PRIVATE',
  SAVE_AS_PDF = 'SAVE_AS_PDF',
}

export const getEstimatePermissionsMatrix = (): Record<
  ESTIMATE_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => {
  return {
    [ESTIMATE_PERMISSION.MAKE_PRIVATE]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_ANONYMOUS]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_LOGGED]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_OWNER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [ESTIMATE_PERMISSION.SAVE_AS_PDF]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_ANONYMOUS]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_LOGGED]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_OWNER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
  }
}
